import { lazy, Suspense } from 'react';
import trianglepolygon from 'assets/images/homepages/trianglepolygon.svg';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { UrlFirstSegment } from 'utils/global';
import fourgridbg from 'assets/bgImg/fourgridbg.svg';
import defaultimage from 'assets/images/defaultsquare.png';
import popularsvg from 'assets/bgImg/popularpattern.svg';
import { generateLink } from '.';
import { loadable } from 'react-lazily/loadable';
const Button = lazy(() => import('components/buttons/Button'));
const { TranslationMessage } = loadable(() => import('components'), {
	fallback: <>Loading...</>,
});
const { HighlightedMessage } = loadable(() => import('components'), {
	fallback: <>Loading...</>,
});
const { ReadMoreOrLess } = loadable(() => import('components'), {
	fallback: <>Loading...</>,
});
const { Image } = loadable(() => import('components/Image'), {
	fallback: <>Loading...</>,
});

interface Props {
	content: {
		[key: string]: any;
	};
	productList?: any;
	type: string;
}

const ProductLayoutThree = ({ content, productList, type }: Props) => {
	const productData = productList;
	const urlFirstSegment = UrlFirstSegment();

	if (productData?.length > 0) {
		return (
			<div className="grid-section-bg position-relative">
				<div className="fourgridline" style={{ background: `url(${fourgridbg}) no-repeat` }}></div>
				<div className="container ">
					<section className="grid-section row grid1 layout2  py-5">
						<div className="col-md-6">
							<div className="grid-content-section position-relative bg-lines bg-success h-100 p-0 p-sm-5 py-3  d-flex flex-column justify-content-center align-items-start rounded overflow-hidden">
								<img src={trianglepolygon} className="trianglepoly" alt="" />

								<h2 className="text-danger mb-4">
									<HighlightedMessage data={content} value="text" className="font-weight-bold text-success" />
								</h2>
								<h4 className="text-white mb-4">
									<TranslationMessage data={content} value="subtext" />
								</h4>
								<Suspense fallback={<div>Loading...</div>}>
									<Button buttonStyle="btn-gradient--solid" buttonSize="btn--medium" icon type="button" url={content.button_url}>
										<TranslationMessage data={content} value="button_text" />
									</Button>
								</Suspense>
							</div>
						</div>
						<div className="col-md-6">
							<div className="grid-with-four">
								{productData.map((product, index) => (
									<div key={index} className="grid-with-four-item rounded overflow-hidden">
										<div key={index} className="grid-with-four-item rounded overflow-hidden">
											{product.thumb_image ? (
												<Image className="img-fluid" src={product.thumb_image} onErrorSrc={defaultimage} alt={product?.title} />
											) : product?.image ? (
												<Image className="img-fluid" src={product.image} onErrorSrc={defaultimage} alt={product?.title} />
											) : (
												<img src={defaultimage} className="img-fluid" alt="nabil bank" />
											)}
											<span>
												<TranslationMessage data={product} value="title" />
											</span>
											{/* offer tag */}
											{product.product_popularity == 'normal' || '' ? (
												' '
											) : (
												<div className="blinkoffertag" style={{ backgroundImage: `url(${popularsvg})` }}>
													{product.product_popularity}
													{/* <HighlightedMessage data={product} value="product_popularity" /> */}
													{/* <FormattedMessage id="new" /> */}
												</div>
											)}
											<div className="grid-with-four-item-overlay"></div>
											<div className="grid-with-four-item-details">
												<h5 className="text-success font-weight-bold">
													<TranslationMessage data={product} value="title" />
												</h5>
												<h6 className="text-white mb-4">
													<ReadMoreOrLess data={product} value="short_description" charLimit={100} isShowMoreText={false} />
													{/* <TranslationMessage data={product} value="short_description" isHtmlParse /> */}
												</h6>
												<div className="grid-card-link-group">
													<Link to={product.detail_url ? product.detail_url : `${urlFirstSegment}/${type}/${product.category_slug}/${product.slug}`}>
														<FormattedMessage id="product.learn-more" />
													</Link>
													{generateLink(product, product.page_header_settings_first_button_link, 'page_header_settings_first_button_text')}
													{/* <Link to={product.page_header_settings_first_button_link}>
														<TranslationMessage data={product} value="page_header_settings_first_button_text" isHtmlParse />
													</Link> */}
												</div>
											</div>
										</div>
									</div>
								))}
							</div>
						</div>
					</section>
				</div>
			</div>
		);
	} else {
		return null;
	}
};

export { ProductLayoutThree };
